import { envConfig } from '../../envConfig';
import { request } from "../request";

export function getApplicationList(personId:string):Promise<any>{
  return request(
    '/cedar/v1/person/associated/application/list',
    {
      personId: personId
    },
    {
      method: 'POST',
      host: envConfig.apiGetway
    }
  )
}

/**
 * 判断用户是否包含特殊角色需要强制退登
 * write by cursor
 * @returns Promise<{code: number, data: {needLogout: boolean}, msg: string}>
 */
export function checkNeedLogout(): Promise<any> {
  return request(
    '/cedar/v1/person/need/logout',
    {
      appType: 'web',
    },
    {
      method: 'POST',
      host: envConfig.apiGetway
    }
  )
}